export type BrowserNotificationPermission =
  | 'granted'
  | 'denied'
  | 'default'
  | 'unsupported'

export function isSupported(): boolean {
  return typeof window !== 'undefined' && typeof Notification !== 'undefined'
}

export function getPermission(): BrowserNotificationPermission {
  if (!isSupported()) return 'unsupported'
  return Notification.permission as 'granted' | 'denied' | 'default'
}

/** Pedir permissão — chamar apenas a partir de um gesto do usuário. */
export async function requestPermission(): Promise<BrowserNotificationPermission> {
  if (!isSupported()) return 'unsupported'
  try {
    const result = await Notification.requestPermission()
    return result as 'granted' | 'denied' | 'default'
  } catch {
    return getPermission()
  }
}

export function showBrowserNotification(params: {
  title: string
  body: string
  tag: string
}): void {
  if (!isSupported()) return
  if (Notification.permission !== 'granted') return

  try {
    const notification = new Notification(params.title || 'PASI QG', {
      body: params.body || '',
      icon: '/favicon.ico',
      tag: params.tag,
    })

    notification.onclick = () => {
      try {
        window.focus()
      } catch {
        // ignore
      }
      notification.close()
    }
  } catch {
    // ignore — browsers can throw if permission changed mid-flight
  }
}
